export default {"src":"/_next/static/media/ico_times.cf4ebb1d.svg","height":24,"width":24};